import { FC, Fragment, useReducer, useState } from 'react';

import { ListRestart } from 'lucide-react';
import { isNonNullish } from 'remeda';
import { toast } from 'sonner';
import useSWR from 'swr';

import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';

import { ProviderSlotCard } from './providerSlotCard/ProviderSlotCard';

import css from './SyncSlotsButton.module.css';

import { slotService } from 'v2/api/slotService';
import { handleHttpError } from 'v2/utils';

interface SyncSlotsButtonProps {
  onSuccess: VoidFunction;
}

export const SyncSlotsButton: FC<SyncSlotsButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);
  const [trigger, setTrigger] = useState(false);

  const { data, isLoading } = useSWR(trigger && 'getSyncSlots', slotService.getSyncSlots, {
    onSuccess: () => {
      setOpen();
    },
    onError: handleHttpError,
    loadingTimeout: 5000,
    onLoadingSlow: () => {
      toast.info('Synchronizing slots can take some time. Please be patient');
    },
  });

  const handleClick = () => {
    if (isNonNullish(data)) {
      setOpen();
    } else {
      setTrigger(true);
    }
  };

  return (
    <Fragment>
      <Button
        onClick={handleClick}
        loading={isLoading}
        startIcon={<ListRestart width={22} height={22} />}
        variant="outlined"
        size="large"
      >
        Sync Slots
      </Button>

      <Drawer
        open={isOpen}
        onClose={setOpen}
        slotProps={{ paper: { className: css.providerSlotsDrawer } }}
        anchor="right"
      >
        {data?.map((slot) => <ProviderSlotCard key={slot.gameId} slot={slot} onRevalidate={onSuccess} />)}
      </Drawer>
    </Fragment>
  );
};
